/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { DarkColors } from '@msteams/components-fabric-teams-theme/dist/commonjs/src/teams/TeamsColors';
import * as React from 'react';
import { Theme } from '../../../common/enums/Theme';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { MobileToggle } from '../../components/MobileToggleField/MobileToggleField';

import './EsignMobileCompleteInOrderToggle.scss';

interface EsignMobileCompleteInOrderInputProps {
    checked: boolean;
    onChange: (event: React.MouseEvent<HTMLElement>, checked?: boolean) => void;
}

export const EsignMobileCompleteInOrderToggle: React.FC<EsignMobileCompleteInOrderInputProps> = ({
    checked,
    onChange,
}: EsignMobileCompleteInOrderInputProps): JSX.Element => {
    const host = getAppHost();
    const loc = host.getLocale();

    const containerClass =
        host.getTheme() === Theme.Dark ? 'mobile-complete-after-container-dark' : 'mobile-complete-after-container';

    const borderBottomColor = DarkColors.appGray06;

    return (
        <div className={containerClass} style={{ borderBottomColor }}>
            <div className={'mobile-complete-after-input-wrapper'}>
                <MobileToggle
                    checked={checked}
                    onChange={onChange}
                    text={loc.strings.recipient_list_label_complete_in_order}
                    disabled={false}
                />
            </div>
        </div>
    );
};
